import { Loader2 } from "lucide-react"
import { Skeleton } from "@/components/ui/skeleton"

interface SoilTempChartSkeletonProps {
  message?: string
}

export function SoilTempChartSkeleton({ message }: SoilTempChartSkeletonProps) {
  return (
    <div className="space-y-4">
      {/* Title skeleton */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-64" />
        <Skeleton className="h-5 w-32" />
      </div>

      {/* Chart skeleton with axis lines for visual structure */}
      <div className="h-[400px] bg-gray-50 rounded-lg relative overflow-hidden animate-pulse">
        {/* Y-axis */}
        <div className="absolute left-0 top-0 bottom-0 w-12 border-r border-gray-200" />

        {/* X-axis */}
        <div className="absolute left-12 right-0 bottom-0 h-8 border-t border-gray-200" />

        {/* Grid lines */}
        <div className="absolute left-12 right-0 top-0 bottom-8 flex flex-col justify-between p-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-px bg-gray-200" />
          ))}
        </div>

        {/* Pulsing gradient to show activity */}
        <div className="absolute inset-0 bg-linear-to-r from-transparent via-white/50 to-transparent animate-shimmer" />
      </div>

      {/* Loading message */}
      {message && (
        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>{message}</span>
        </div>
      )}
    </div>
  )
}
